module.exports = __webpack_public_path__ + "img/coin.2fb45032.svg";